import { Box, FormControl, FormLabel, Stack } from '@chakra-ui/react';
import OrderedLists from 'components/presentational/OrderedLists';
import {
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';

const RegionLocationsOrderedList = ({
    darkMode,
    regionId,
    values,
    setFieldValue,
}) => (
    <FormControl sx={{ margin: '0 !important' }}>
        <Stack
            direction="row"
            spacing={stackSpacing}
            sx={{ ...stackStyling(), height: 'auto' }}>
            <FormLabel sx={formLabelStyling(darkMode)}>Locations</FormLabel>
            <Box flex={1} maxWidth="400px">
                <OrderedLists
                    setState={(payload) =>
                        setFieldValue('trunkLocations', payload.trunkLocations)
                    }
                    dependency={regionId}
                    fieldFetch="/trunklocations/"
                    attribute="trunkLocations"
                    header=""
                    placeholder="- Select Locations -"
                    modalState={values}
                />
            </Box>
        </Stack>
    </FormControl>
);

export default RegionLocationsOrderedList;
